module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av656-79a7b63ee4dcc1b1093a4da35a95d879.jpg";